/*
 * 犬｜画面内モーダル
 *
 * 商品詳細（詳しく見る）と動画の拡大で共用する。<dialog> の開閉だけを担い、
 * カート追加は Horizon の product-form-component に任せる。
 *
 * - [data-inu-modal-open="ダイアログのid"] を押すと開く
 * - [data-inu-modal-close] と背景クリック、Esc で閉じる
 * - 閉じたら中の動画を止める（音声つきの拡大動画が裏で鳴り続けるのを防ぐ）
 * - [data-inu-variant-select] の選択を、フォームの hidden input（ref="variantId"）へ写す
 */

(() => {
  // セクションが複数回描画されても、リスナーを重ねて登録しない
  if (window.inuModalReady) return;
  window.inuModalReady = true;

  // 選ばれている購入オプションの価格を、カードの金額欄にそろえる
  const syncPlanPrice = (detail) => {
    if (!detail) return;
    const priceOutput = detail.querySelector('[data-inu-detail-price]');
    const selectedPrice = detail
      .querySelector('[data-inu-plan]:checked')
      ?.closest('.inu-plans__option')
      ?.querySelector('.inu-yen__value');
    if (priceOutput && selectedPrice) priceOutput.textContent = selectedPrice.textContent;
  };

  const openModal = (dialog) => {
    if (typeof dialog.showModal !== 'function') return;
    dialog.showModal();

    // 定期便専用の商品は最初から定期が選ばれているので、金額もそちらに合わせる
    dialog.querySelectorAll('[data-inu-detail]').forEach(syncPlanPrice);

    // 拡大した動画は先頭から再生し直す。音声はモーダル側の video 要素が持つ
    const video = dialog.querySelector('video');
    if (video) {
      video.currentTime = 0;
      const played = video.play();
      if (played && typeof played.catch === 'function') {
        // 自動再生がブラウザに拒否されても、コントロールから再生できるので握りつぶす
        played.catch(() => {});
      }
    }
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-inu-modal-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('data-inu-modal-open'));
      if (dialog) {
        event.preventDefault();
        openModal(dialog);
      }
      return;
    }

    const closer = event.target.closest('[data-inu-modal-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }

    // 背景（::backdrop）のクリックは dialog 自身が click の対象になる
    if (event.target instanceof HTMLDialogElement) {
      event.target.close();
    }
  });

  // close は bubble しないのでキャプチャで拾う
  document.addEventListener(
    'close',
    (event) => {
      if (!(event.target instanceof HTMLDialogElement)) return;
      event.target.querySelectorAll('video').forEach((video) => video.pause());
    },
    true
  );

  // 購入オプション（一回のみ / 定期）の中身は inu-selling-plan.js が持つ。
  // モーダルの select は Horizon のバリアントピッカーではないので、
  // 選択が変わったことをこちらから知らせる

  // バリアント選択をフォームへ反映する。product-form-component は
  // ref="variantId" の hidden input を読むため、select の値をそこへ写す
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-inu-variant-select]');
    if (!select) return;

    const detail = select.closest('[data-inu-detail]');
    const variantInput = detail?.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = select.value;

    const selectedOption = select.options[select.selectedIndex];
    const priceOutput = detail?.querySelector('[data-inu-detail-price]');
    if (priceOutput && selectedOption?.dataset.price) {
      priceOutput.textContent = selectedOption.dataset.price;
    }

    // 定期の選択肢と価格、食材の内訳、送料無料の案内をこのバリアントのものに描き直させる
    detail?.querySelectorAll('inu-selling-plans, inu-meal-choices, inu-free-shipping').forEach((element) => {
      if (typeof element.setVariant === 'function') element.setVariant(select.value);
    });

    // 描き直したあとの選択に合わせて金額欄をそろえる（定期便専用は定期が選ばれている）
    syncPlanPrice(detail);
  });

  // 定期を選んだら、下に出している金額もそのプランの価格にそろえる
  document.addEventListener('change', (event) => {
    const radio = event.target.closest('[data-inu-plan]');
    if (!radio) return;

    const detail = radio.closest('[data-inu-detail]');
    const priceOutput = detail?.querySelector('[data-inu-detail-price]');
    const selectedPrice = radio.closest('.inu-plans__option')?.querySelector('.inu-yen__value');
    if (priceOutput && selectedPrice) {
      priceOutput.textContent = selectedPrice.textContent;
    }
  });
})();
